enum ModalEvents {
  Finish = 'showFinishModal',
  Material = 'showMaterialModal',
  HardwarePackage = 'showHardwarePackageModal',
  PartitionType = 'showPartionTypeModal',
  Screens = 'showScreensModal',
  Series = 'showSeriesModal',
  Feedback = 'showFeedback',
  Notes = 'showNotesModal',
  DuplicateNotesToRooms = 'duplicateNotesToRooms',
  CancelConfirm = 'showCancelConfirmModal',
  ProjectDuplicate = 'showProjectDuplicate',
  LeadInfoModal = 'showLeadInfoModal',
  AssignmentQuestionsModal = 'showAssignmentQuestionsModal',
  AssignmentAnswersModal = 'showAssignmentAnswersModal',
  LeadAssignedDetailsModal = 'showLeadAssignedDetailsModal',
  LockersStyleUpdatePrompt = 'showLockersStyleUpdatePrompt',
  GenderAndFloor = 'genderAndFloorModal',
  CommonErrorModal = 'showCommonErrorModal',
  SuggestedPartsModal = 'showSuggestedPartsModal',
  PaintModal = 'showPaintModal',
  LargeShipmentRequestFeedbackModal = 'showLargeShipmentRequestFeedbackModal',
  LargeShipmentRequestCompletionModal = 'showLargeShipmentRequestCompletionModal',
  LinkProjects = 'showProjectLinkModal',
  ProjectTask = 'showProjectTaskModal',
  ApplySettingsToRooms = 'showApplySettingsToRoomsModal',
}

export default ModalEvents;
